import InputFilterText from './InputFilterText';
export default InputFilterText;
